import { render, staticRenderFns } from "./DocumentHistoryDialog.vue?vue&type=template&id=a2a5f0ca"
import script from "./DocumentHistoryDialog.vue?vue&type=script&lang=js"
export * from "./DocumentHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports